
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { getAllProfessions } from "@/data/professionSolutions";
import { ArrowRight } from "lucide-react";

const ProfessionList: React.FC = () => {
  const professions = getAllProfessions();
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {professions.map((profession) => (
        <Card key={profession.slug} className="hover:shadow-md transition-shadow">
          <CardContent className="p-6">
            <h3 className="text-xl font-heading font-bold mb-3 text-fabre-gray">
              {profession.title.replace("Solutions de recyclage pour ", "")}
            </h3>
            
            <p className="text-gray-600 mb-4 line-clamp-3">
              {profession.description}
            </p>
            
            <Link 
              to={`/metiers/${profession.slug}`} 
              className="flex items-center text-fabre-green hover:text-fabre-darkgreen font-medium"
            >
              Voir les solutions 
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ProfessionList;
